import { Jersey } from '@/ui/components';

interface PlayerInfoProps {
  name: string;
  position?: string | null;
  jerseySrc: string;
  flagSrc?: string | null;
}

export default function PlayerInfo({ name, position, jerseySrc, flagSrc }: PlayerInfoProps) {
  return (
    <div className="flex items-center gap-2">
      <Jersey jerseySrc={jerseySrc} size={32} flagSrc={flagSrc || undefined} />
      <div className="flex flex-col min-w-0">
        <span className="truncate font-robotoMedium font-medium text-[14px] leading-[20px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
          {name}
        </span>
        {position && (
          <span className="truncate font-robotoRegular font-normal text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
            {position}
          </span>
        )}
      </div>
    </div>
  );
}
